import { createFileRoute } from "@tanstack/react-router"
import { WidgetFunnelPage } from "@/pages/widget-stats"

export const Route = createFileRoute("/(analytics)/widget-stats")({
	component: WidgetFunnelPage,
})
